import { render, staticRenderFns } from "./Trust.vue?vue&type=template&id=a15995ca&"
import script from "./Trust.vue?vue&type=script&lang=js&"
export * from "./Trust.vue?vue&type=script&lang=js&"
import style0 from "./Trust.vue?vue&type=style&index=0&id=a15995ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports